import { jsxs, Fragment, jsx } from 'react/jsx-runtime';
import { styled } from 'styled-components';

const CornerTopLet = styled.div.withConfig({
  displayName: "ResizeableEdges__CornerTopLet",
  componentId: "sc-496bd149-0"
})([
  `position:absolute;top:calc(-1 * var(--corner-offset));left:calc(-1 * var(--corner-offset));width:calc(2 * var(--corner-offset));height:calc(2 * var(--corner-offset));z-index:5;cursor:nwse-resize;`
]);
const CornerTopRight = styled.div.withConfig({
  displayName: "ResizeableEdges__CornerTopRight",
  componentId: "sc-496bd149-1"
})([
  `position:absolute;top:calc(-1 * var(--corner-offset));right:calc(-1 * var(--corner-offset));width:calc(2 * var(--corner-offset));height:calc(2 * var(--corner-offset));z-index:5;cursor:nesw-resize;`
]);
const CornerBottomLeft = styled.div.withConfig({
  displayName: "ResizeableEdges__CornerBottomLeft",
  componentId: "sc-496bd149-2"
})([
  `position:absolute;bottom:calc(-1 * var(--corner-offset));left:calc(-1 * var(--corner-offset));width:calc(2 * var(--corner-offset));height:calc(2 * var(--corner-offset));z-index:5;cursor:nesw-resize;`
]);
const CornerBottomRight = styled.div.withConfig({
  displayName: "ResizeableEdges__CornerBottomRight",
  componentId: "sc-496bd149-3"
})([
  `position:absolute;bottom:calc(-1 * var(--corner-offset));right:calc(-1 * var(--corner-offset));width:calc(2 * var(--corner-offset));height:calc(2 * var(--corner-offset));z-index:5;cursor:nwse-resize;`
]);
const BottomEdge = styled.div.withConfig({
  displayName: "ResizeableEdges__BottomEdge",
  componentId: "sc-496bd149-4"
})([
  `position:absolute;bottom:-5px;left:0;right:0;height:10px;z-index:4;cursor:ns-resize;`
]);
const RightEdge = styled.div.withConfig({
  displayName: "ResizeableEdges__RightEdge",
  componentId: "sc-496bd149-5"
})([
  `position:absolute;top:0;bottom:0;right:-5px;width:10px;z-index:4;cursor:ew-resize;`
]);
const LeftEdge = styled.div.withConfig({
  displayName: "ResizeableEdges__LeftEdge",
  componentId: "sc-496bd149-6"
})([
  `position:absolute;top:0;bottom:0;left:-5px;width:10px;z-index:4;cursor:ew-resize;`
]);
const TopEdge = styled.div.withConfig({
  displayName: "ResizeableEdges__TopEdge",
  componentId: "sc-496bd149-7"
})([
  `position:absolute;top:-5px;left:0;right:0;height:10px;z-index:4;cursor:ns-resize;`
]);
const ResizeableEdges = ({ onResizeMouseDown }) => {
  return /* @__PURE__ */ jsxs(Fragment, {
    children: [
      /* @__PURE__ */ jsx(CornerTopLet, {
        "data-from": "top-left",
        onMouseDown: onResizeMouseDown
      }),
      /* @__PURE__ */ jsx(CornerTopRight, {
        "data-from": "top-right",
        onMouseDown: onResizeMouseDown
      }),
      /* @__PURE__ */ jsx(CornerBottomLeft, {
        "data-from": "bottom-left",
        onMouseDown: onResizeMouseDown
      }),
      /* @__PURE__ */ jsx(CornerBottomRight, {
        "data-from": "bottom-right",
        onMouseDown: onResizeMouseDown
      }),
      /* @__PURE__ */ jsx(BottomEdge, {
        "data-from": "bottom",
        onMouseDown: onResizeMouseDown
      }),
      /* @__PURE__ */ jsx(RightEdge, {
        "data-from": "right",
        onMouseDown: onResizeMouseDown
      }),
      /* @__PURE__ */ jsx(LeftEdge, {
        "data-from": "left",
        onMouseDown: onResizeMouseDown
      }),
      /* @__PURE__ */ jsx(TopEdge, {
        "data-from": "top",
        onMouseDown: onResizeMouseDown
      })
    ]
  });
};

export { ResizeableEdges };
//# sourceMappingURL=ResizeableEdges.js.map
